export const COMMENTS__24 = '<svg xmlns="http://www.w3.org/2000/svg" data-id="SVG_COMMENTS__24" width="20" height="19" viewBox="0 0 20 19"><g fill="none" fill-rule="evenodd"><g stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M12.626 9.533H5M15 5.533H5M.75 5.533V16.25a1.5 1.5 0 0 0 2.795.757l1.947-3.33H19.25V2.844a1.5 1.5 0 0 0-1.5-1.5h-17"/></g><path d="M-2-3h24v24H-2z"/></g></svg>';
export const COMMENTS_16 = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
<g fill="none" fill-rule="evenodd">
    <path stroke="#323F4D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.987 6.99h-5.77M11.784 3.962H4.217M1 3.962v8.11a1.136 1.136 0 0 0 2.115.574l1.474-2.52H15V2.291a1.5 1.5 0 0 0-1.5-1.5H1"/>
</g>
</svg>
`;



// WEBPACK FOOTER //
// ./src/universal/components/svg-def/comments.js